<app-dialog
	modalTitle="Benefício - Fim de Vigência"
	titleButton="Salvar"
	secTitleButton="Cancelar"
	[secButton]="true"
	[hideFooter]="false"
	[noMargins]="true"
	[disabled]="form.invalid"
	(dialogClose)="closeModal()"
	(dialogSave)="onContinue()"
>
	<div class="container" [formGroup]="form">
		<div class="line">
			<mat-form-field class="form-field" title="Benefício" appearance="outline">
				<mat-label>Benefício</mat-label>
				<input
					type="text"
					matInput
					placeholder="Benefício"
					formControlName="name"
				/>
			</mat-form-field>
			<mat-form-field
				class="form-field"
				title="Fim de Vigência"
				appearance="outline"
			>
				<mat-label>Fim de Vigência</mat-label>
				<input
					matInput
					placeholder="Fim de Vigência"
					formControlName="date"
					[matDatepicker]="picker"
				/>
				<mat-datepicker-toggle matSuffix [for]="picker">
					<mat-icon
						matDatepickerToggleIcon
						svgIcon="sanus-calendar-blue"
					></mat-icon>
				</mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
				<mat-error *ngIf="form.get('date')?.hasError('required')">
					Campo obrigatório
				</mat-error>
			</mat-form-field>
		</div>
	</div>
</app-dialog>
